import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import themeColors, { themeFontSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { css } from "styled-components";

interface Props {
    totalItemCount?: number;
    pageSize?: number;
    styles?: {
        countText?: TypographyPresentationProps;
        itemsText?: TypographyPresentationProps;
    };
}

export interface ProductListProductCountStyles {
    wrapper?: InjectableCss;
    countText?: TypographyPresentationProps;
    itemsText?: TypographyPresentationProps;
    queryText?: TypographyPresentationProps;
}

export const productCountStyles: ProductListProductCountStyles = {
    wrapper: {
        css: css`
            margin-top: .625rem;
            color: ${themeColors.colorCharcoalGrey};
            font-size: ${themeFontSizes.size14};
            letter-spacing: 0;
            font-style: italic;
            font-weight: 500;
        `,
    },
    countText: {
        css: css`
            white-space: nowrap;
        `,
    },
    queryText: {
        css: css`
            white-space: nowrap;
            font-weight: bold;
        `,
    },
};
const styles = productCountStyles;
const ProductCountDisplay: FC<Props> = ({ totalItemCount, pageSize}) => {
    if (!totalItemCount || !pageSize) {
        return null;
    }

    const itemsText = totalItemCount !== 1 ? " Results" : " Result";
    const pageSizeNew = totalItemCount < pageSize ? totalItemCount : pageSize;

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <Typography {...styles.itemsText}>Showing </Typography>
                <Typography {...styles.countText} data-test-selector="productListCountText">
                    {pageSizeNew}
                </Typography>
                <Typography {...styles.itemsText}> of </Typography>
                <Typography {...styles.countText} data-test-selector="productListCountText">
                    {totalItemCount}
                </Typography>
                <Typography {...styles.itemsText}>{translate(itemsText)}</Typography>
            </StyledWrapper>
        </>
    );
};

export default ProductCountDisplay;